import { useState, useEffect } from "react";

import CreatableSelect from "react-select/creatable";
import { useAuthSelector } from "../../services/selectors/authSelector";

const DEFAULT_CONSULTATION = { label: 'Consultation provided', value: 'Consultation provided' };

export const DeliveryConsultationDropdown = ({ consultation, setConsultation }) => {
    const { pharmacyId } = useAuthSelector();

    // const [optionsList, setOptionsList] = useState([
    //     { label: '*** Dose Changed ***', value: '*** Dose Changed ***' },
    //     { label: '*** Consult provided ***', value: '*** Consult provided ***' },
    //     { label: '*** Consult offered but refused by patient ***', value: '*** Consult offered but refused by patient ***' }
    // ])

    const [optionsList, setOptionsList] = useState([
        { label: 'Dose Changed', value: 'Dose Changed' },
        { label: 'Consult offered but refused by patient', value: 'Consult offered but refused by patient' },
        { label: 'In person ', value: 'In person' },
        { label: 'Call made', value: 'Call made' },
        { label: 'Written', value: 'Written' },
        { label: 'OAT Restart', value: 'OAT Restart' },
        DEFAULT_CONSULTATION,
    ])

    const handleCreateOption = (inputValue) => {
        const newOption = { label: inputValue, value: inputValue };
        setConsultation(newOption)
        setOptionsList((prevOptions) => [...prevOptions, newOption]);
    }

    const handleSelect = (value) => {
        setConsultation(value)
    }

    useEffect(() => {
        if (Number(pharmacyId) === 865 && !consultation) {
            setConsultation(DEFAULT_CONSULTATION);
        }
    }, [consultation, pharmacyId, setConsultation])

    return (
        <>
            <div className="">
                <CreatableSelect
                    onChange={handleSelect}
                    value={consultation}
                    options={optionsList}
                    placeholder="Select or add a consultation"
                    isSearchable
                    className="basic-multi-select"
                    classNamePrefix="react-select"
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                    onCreateOption={handleCreateOption}
                />
            </div>
        </>
    )
}


export const NewRxesConsultationDropdown = ({ type, rxData, setCounsellingValues, counsellingValues }) => {

    const [selectedValue, setSelectedValue] = useState(null);
    let optionsList;

    if (type === 'new_rx') {
        optionsList = [
            { label: 'Consultation provided', value: 'Consultation provided' },
            { label: 'Consult offered but refused by patient', value: 'Consult offered but refused by patient' },
            { label: 'OAT Restart', value: 'OAT Restart' },
        ];
    } else {
        optionsList = [
            { label: 'Call made', value: 'Call made' },
            { label: 'In person ', value: 'In person' },
            { label: 'Written', value: 'Written' },
        ];
    }

        // Set initial selected value on mount/update
        useEffect(() => {
            const entry = counsellingValues?.find(item => item.rxid === rxData?.id);
            setSelectedValue(entry?.dropdownValue || null);
        }, [rxData?.id, counsellingValues]);
    

    // Prevent duplicate rxid entries
    useEffect(() => {
        setCounsellingValues(prev => {
            const exists = prev.some(entry => entry?.rxid === rxData?.id);
            if (!exists) {
                return [
                    ...prev,
                    {
                        rxid: rxData?.id,
                        dropdownValue: null
                        // type === 'pending_counselling_rxes' ? null : { // Change made here
                        //     label: 'Consultation provided',
                        //     value: 'Consultation provided'
                        // }
                    }
                ];
            }
            return prev;
        });
    }, [rxData?.id]); // depend only on id

    const handleSelect = (value) => {
        setSelectedValue(value); // update local
        setCounsellingValues(prev =>
            prev.map(entry =>
                entry.rxid === rxData.id
                    ? { ...entry, dropdownValue: value }
                    : entry
            )
        )
    }


    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            borderColor: !selectedValue ? 'red' : '#d1d5db', // red if empty, gray if selected
            boxShadow: state.isFocused
                ? (!selectedValue ? '0 0 0 1px red' : '0 0 0 1px #2684FF')
                : 'none',
            '&:hover': {
                borderColor: !selectedValue ? 'red' : '#2684FF',
            },
        }),
    };

    return (
        <>
            <div className="bg-gray-100 rounded-md mb-3">
                <CreatableSelect
                    onChange={handleSelect}
                    styles={customStyles}
                    value={counsellingValues.find(entry => entry.rxid === rxData.id)?.dropdownValue}
                    options={optionsList}
                    placeholder="Select or add a consultation"
                    className="basic-multi-select"
                    classNamePrefix="react-select"
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                />
            </div>
        </>
    )
}
